var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckedItem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 19,
    height: 19,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63405 13.7196C8.86494 14.4399 7.66889 14.4399 6.89978 13.7196L5.03519 11.9734C4.47477 11.4485 4.47477 10.5592 5.03519 10.0344V10.0344C5.54654 9.55547 6.34192 9.55605 6.85256 10.0357L8.26691 11.3642L14.1471 5.85163C14.6581 5.37259 15.4531 5.37239 15.9643 5.85117V5.85117C16.525 6.37626 16.525 7.26595 15.9643 7.79104L9.63405 13.7196Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedItem);
export default __webpack_public_path__ + "static/media/checked-item.9bb0b5615cc0f0e3413b9da02650f2f5.svg";
export { ForwardRef as ReactComponent };